import React, { createContext, useState, useCallback } from "react";
import { useLazyQuery } from "@apollo/client";
import { GET_JUDGMENTS, CURRENT_JUDGEMENTS } from "schema/Judgments";
import PropTypes from "prop-types";

export const JudgementContext = createContext();

export default function JudgementContextProvider({ children }) {
  const [
    getAllJudgements,
    { loading: allJudgementsLoading, data: allJudgements, fetchMore },
  ] = useLazyQuery(GET_JUDGMENTS);
  const [getCurrentJudgements, { data: currentJudgements }] = useLazyQuery(
    CURRENT_JUDGEMENTS
  );
  const [allTheJudgements, setAllTheJudgements] = useState(null);
  const [allCurrentJudgements, setAllCurrentJudgements] = useState(null);

  const getJudgements = useCallback(() => {
    getAllJudgements({
      variables: {
        region: "ng",
        type: "judgement",
        options: {
          take: 2,
          skip: 1,
        },
      },
    });
  }, []);

  const getAllCurrentJudgements = useCallback(() => {
    getCurrentJudgements({
      variables: {},
    });
  }, []);

  React.useEffect(() => {
    if (allJudgements) {
      if (allJudgements.error) {
        console.log(allJudgements.error);
      } else {
        setAllTheJudgements(allJudgements);
      }
    }
  }, [allJudgements]);

  React.useEffect(() => {
    if (currentJudgements) {
      if (currentJudgements.error) {
        console.log(currentJudgements.error);
      } else {
        setAllCurrentJudgements(currentJudgements);
      }
    }
  }, [currentJudgements]);

  return (
    <JudgementContext.Provider
      value={{
        getJudgements,
        allJudgementsLoading,
        allJudgements,
        fetchMore,
        allTheJudgements,
        setAllTheJudgements,
        allCurrentJudgements,
        getAllCurrentJudgements,
      }}
    >
      {children}
    </JudgementContext.Provider>
  );
}

JudgementContext.propTypes = {
  children: PropTypes.node.isRequired,
};
